const defaultFood = {
  name: "",
  description: "",
  note: "",
  category: "",
  sizes: [],
  cena: "",
  price: 0,
  groceries: [],
  code: null,
  prilog: [],
  type: [],
  attachments: [],
  selectedPrices: [],
  labels: [],
  translations: [],
  is_package: false,
  package_min_items: null,
  package_max_items: null,
};

const defaultGrocery = {
  name: "",
  measure: "",
  code: "",
  price: "",
  min_quantity: ""
};

export { defaultFood, defaultGrocery };
